import script from "./EmpMore.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpMore.vue?vue&type=script&setup=true&lang=ts"

import "./EmpMore.vue?vue&type=style&index=0&id=438ae890&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438ae890"]])

export default __exports__